import React from "react";
import { Link } from "react-router-dom";

const EditStaticManagement = () => {
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">Content Management System</h4>
          </div>
          <div className="StaticBox">
            <div className="TextBox">
              <h6>About Us</h6>
              <aside className="p-0">
                <textarea className="form-control border-0" rows="5">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Aenean euismod bibendum laoreet. Proin gravida dolor sit amet
                  lacus accumsan et viverra justo commodo. Proinsodales pulvinar
                  sic tempor. Sociis natoque penatibus et magnis dis par turient
                  monte nascetur ridiculus mus. Nam fermentum, nulla luctus
                  pharetra vulputate, felis tellus mollis orci, sed rhoncu s
                  pronin sapien nunc accuan eget. orem ipsum dolor sit amet,
                  consectetur adipiscing elit. Aenean euismod bibendum l
                </textarea>
              </aside>
            </div>
            <div className="TextBox">
              <h6>Contact Us</h6>
              <aside className="p-0">
                <textarea className="form-control border-0" rows="5">
                  126151621233
                </textarea>
              </aside>
            </div>
            <div className="TextBox">
              <h6>FAQ</h6>
              <aside className="p-0">
                <textarea className="form-control border-0" rows="5">
                  Questions 1
                </textarea>
              </aside>
              <aside className="p-0">
                <textarea className="form-control border-0" rows="5">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Aenean euismod bibendum laoreet. Proin gravida dolor sit amet
                  lacus accumsan et viverra justo commodo. Proinsodales pulvinar
                  sic tempor. Sociis natoque penatibus et magnis dis par turient
                  monte nascetur ridiculus mus. Nam fermentum, nulla luctus
                  pharetra vulputate, felis tellus mollis orci, sed rhoncu s
                  pronin sapien nunc accuan eget. orem ipsum dolor sit amet,
                  consectetur adipiscing elit. Aenean euismod bibendum l
                </textarea>
              </aside>
            </div>
            <a href="javascript:void(0);" className="AddQuestionbtn">
              + Add Question
            </a>
            <div className="TextBox">
              <h6>Term &amp; Conditions</h6>
              <aside className="p-0">
                <textarea className="form-control border-0" rows="5">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Aenean euismod bibendum laoreet. Proin gravida dolor sit amet
                  lacus accumsan et viverra justo commodo. Proinsodales pulvinar
                  sic tempor. Sociis natoque penatibus et magnis dis par turient
                  monte nascetur ridiculus mus. Nam fermentum, nulla luctus
                  pharetra vulputate, felis tellus mollis orci, sed rhoncu s
                  pronin sapien nunc accuan eget. orem ipsum dolor sit amet,
                  consectetur adipiscing elit. Aenean euismod bibendum l
                </textarea>
              </aside>
            </div>
            <div className="TextBox">
              <h6>Privacy Policy</h6>
              <aside className="p-0">
                <textarea className="form-control border-0" rows="5">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Aenean euismod bibendum laoreet. Proin gravida dolor sit amet
                  lacus accumsan et viverra justo commodo. Proinsodales pulvinar
                  sic tempor. Sociis natoque penatibus et magnis dis par turient
                  monte nascetur ridiculus mus. Nam fermentum, nulla luctus
                  pharetra vulputate, felis tellus mollis orci, sed rhoncu s
                  pronin sapien nunc accuan eget. orem ipsum dolor sit amet,
                  consectetur adipiscing elit. Aenean euismod bibendum l
                </textarea>
              </aside>
            </div>
            <Link to={"/staticContent"} className="Button">
              Save Changes
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditStaticManagement;
